export default {
    ANDROID_CHROME: 'Android Chrome',
    DESKTOP_CHROME: 'Desktop Chrome',
    ANDROID_OTHER: 'Android Other',
    ANDROID_ALL: 'Android All',
    IOS_ALL: 'IOS All',
    MAC_ALL: 'MAC All',
    MAC_CHROME: 'MAC Chrome',
    EDGE_PC: 'Edge PC',
    EDGE_ANDROID: 'Edge Android',
    DESKTOP_CHROME_EDGE: 'Desktop Chrome & Edge',
    ANDROID_CHROME_EDGE: 'Android Chrome & Edge',
    DESKTOP_OPERA: 'Desktop Opera',
    DESKTOP_CHROME_EDGE_OPERA: 'Desktop Chrome & Edge & Opera'
};


// WEBPACK FOOTER //
// ./src/scenes/AdkFeeds/device.config.js